module.exports = __webpack_public_path__ + "img/safeguard.bb830fd7.png";